'use strict';

/**
 * A directive to that takes an SVG from our $templateCache and injects it into the DOM.
 * Very similar to svg-icon, but with styles more suited for image layout than icon layout.
 * Example:
 * <svg-img img-id="logo"></svg-img>
 */

(function () {
  'use strict';

  angular.module('msUtility').directive('svgImg', svgImg);

  svgImg.$inject = ['$templateCache', '$log'];

  /* @ngInject */
  function svgImg($templateCache, $log) {
    var directive = {
      link: link,
      restrict: 'E'
    };
    return directive;

    function link(scope, element, attrs) {
      attrs.$observe('imgId', function (imgId) {
        changeSvg(element, imgId);
      });
    }

    function changeSvg(element, imgId) {
      // This expects the icon to already be in $templateCache.
      var svgImg = $templateCache.get(imgId + '.svg');
      if (svgImg) {
        element.empty();
        element.append(svgImg);
      } else {
        $log.error('SVG icon not found.', imgId, element);
      }
    }
  }
})();